module.exports = __webpack_public_path__ + "static/media/logo-negativo.3bcb2be9.svg";